import React, { FC, memo, ReactNode } from 'react';
import { ReactComponent as SuccessIcon } from 'shared/assets/icons/SuccessIcon.svg';
import { ReactComponent as SuccessScreenImage } from 'shared/assets/images/ModernSuccess.svg';

interface SuccessScreenProps {
  title?: string;
  description?: string;
  additionalInfo?: ReactNode;
  actions?: ReactNode;
}

export const SuccessScreen: FC<SuccessScreenProps> = memo((props) => {
  const { title, description, additionalInfo, actions } = props;

  return (
    <>
      <div className="flex flex-col items-center wideDesktop:hidden space-y-6 w-full">
        <div className="bg-white rounded-lg p-6 w-full text-center">
          <SuccessIcon className="mb-4 mx-auto" />
          <div className="text-success font-semibold text-2xl text-center mb-3">{title}</div>
          <div className="text-primaryLight font-semibold text-lg text-center mb-4">{description}</div>
          {additionalInfo && <div className="mb-4 w-full">{additionalInfo}</div>}
          {actions && <div className="w-full">{actions}</div>}
        </div>
      </div>
      <div className="hidden space-x-6 justify-center items-start wideDesktop:flex">
        <div className="bg-white rounded-lg w-full p-6 flex items-center justify-center">
          <SuccessScreenImage className="w-[500px] h-auto my-6" />
        </div>
        <div className="bg-white rounded-lg p-6 w-[350px] flex-shrink-0 text-center">
          <SuccessIcon className="mb-4 mx-auto" />
          {title && <div className="font-semibold text-lg mb-2 text-primary">{title}</div>}
          {description && <div className="text-md text-primaryLight mb-4">{description}</div>}
          {additionalInfo && <div className="mb-4 w-full">{additionalInfo}</div>}
          {actions && <div className="w-full">{actions}</div>}
        </div>
      </div>
    </>
  );
});
